export default "__VITE_ASSET__L83e0zGJ__"